import React from 'react';

import { ConfirmDeleteEventModal } from './ConfirmDeleteEventModal';
import { RemoveRecurrentEventModal } from './RemoveRecurrentEventModal';

export function CalendarModals() {
  return (
    <React.Fragment>
      <RemoveRecurrentEventModal />
      <ConfirmDeleteEventModal />
    </React.Fragment>
  );
}
